/**
 * Recursively transforms dropdown fields in form data using metadata rules.
 * Supports single-select, multi-select, and deeply nested structures.
 *
 * @param {Object|Array} data - The current node of form data being transformed.
 * @param {Object} metadata - The backend metadata (without .response wrapper).
 * @returns {Object|Array} - The transformed data ready for API submission.
 */
export function transformFormPayload(data, metadata) {
  console.log(data, metadata, "helloodatametaaaa transform FUnvtion");
  // // Handle arrays
  // if (Array.isArray(data)) {
  //     return data.map(item => transformFormPayload(item, metadata));
  // }

  // Handle primitives and nulls
  if (typeof data !== "object" || data === null) return data;

  // 🛑 Preserve Date objects
  if (data instanceof Date) return data;

  const transformed = { ...data };

  // Flatten all metadata fields for easy lookup
  // const allFields = Object.values(metadata).flatMap(section => section.fields);
  const allFields = metadata;

  console.log("transform FUnvtion allFields ", allFields);
  console.log("transform FUnvtion transformed ", transformed);

  Object.keys(transformed).forEach((key) => {
    const fieldMeta = allFields.find((f) => f.value === key);
    console.log("transform FUnvtion fieldMeta ", fieldMeta);
    const value = transformed[key];
    console.log("transform FUnvtion value ", value);

    // ✅ Handle dropdowns (single & multi-select)
    if (
      fieldMeta?.type === "dropdown" ||
      (fieldMeta?.type === "multiselect" && Array.isArray(value) && value.length > 0) ||
      fieldMeta?.type === "multi_person"
    ) {
      // if (fieldMeta?.type === "multiselect" && Array.isArray(value) && value.length > 0) {
      if (fieldMeta?.type === "multiselect") {
        // transformed[key] = value.map(v => v[fieldMeta.options_value_key]);
        transformed[key] = value?.map((v) => v?.value || v?.id);
      } else if (fieldMeta?.type === "multi_person" || fieldMeta?.type === "person") {
        // transformed[key] = value.map(v => v[fieldMeta.options_value_key]);
        transformed[key] = value?.map((v) => v?.value || v?.uuid);
      } else {
        // transformed[key] = value[0][fieldMeta.options_value_key];
        transformed[key] = value?.value || value?.id;
      }
      return;
    }

    // ✅ Recurse for nested structures (arrays/objects)
    // if (Array.isArray(value)) {
    //     transformed[key] = value.map(item => transformFormPayload(item, metadata));
    // } else if (typeof value === "object" && value !== null && !(value instanceof Date)) {
    //     transformed[key] = transformFormPayload(value, metadata);
    // }
  });

  return transformed;
}
